import React, { Component } from 'react';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

export class RenderClicToPayPaymentForm extends Component {

    render() {
        const { paymentGateway, handleData, idx } = this.props;

        return (
            <div>
                <FormGroup row>
                    <Label sm={2}>
                        <FormattedMessage id="PaymentGateway.ApiUser" />
                    </Label>
                    <Col sm={10}>
                        <Input type="number" maxLength="50" name="userId" id="userId" value={paymentGateway.userId ? paymentGateway.userId : ''} onChange={evt => handleData(evt, idx)} required />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={2}>
                        <FormattedMessage id="PaymentGateway.Password" />
                    </Label>
                    <Col sm={10}>
                        <Input type="text" maxLength="700" name="accessToken" id="accessToken" value={paymentGateway.accessToken ? paymentGateway.accessToken : ''} onChange={evt => handleData(evt, idx)} required />
                    </Col>
                </FormGroup>
            </div>
        );
    }
}